import { render, staticRenderFns } from "./IMEIQuestion.vue?vue&type=template&id=59c8766a&"
import script from "./IMEIQuestion.vue?vue&type=script&lang=js&"
export * from "./IMEIQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports